import { render, staticRenderFns } from "./CustomAttributesSelector.vue?vue&type=template&id=c5086f9a&scoped=true&"
import script from "./CustomAttributesSelector.vue?vue&type=script&lang=js&"
export * from "./CustomAttributesSelector.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttributesSelector.vue?vue&type=style&index=0&id=c5086f9a&prod&lang=scss&scoped=true&"
import style1 from "./CustomAttributesSelector.vue?vue&type=style&index=1&id=c5086f9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5086f9a",
  null
  
)

export default component.exports